import { render, staticRenderFns } from "./UserVignette.vue?vue&type=template&id=20aaf9c5&scoped=true"
import script from "./UserVignette.vue?vue&type=script&lang=js"
export * from "./UserVignette.vue?vue&type=script&lang=js"
import style0 from "./UserVignette.vue?vue&type=style&index=0&id=20aaf9c5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20aaf9c5",
  null
  
)

export default component.exports